<template>
  <ion-page class="bg-white">
    <LargeNavbar
      is-large
      show-back-button
      :show-actions="false"
      @back-button="onBackButton"
      :title="`${t('invoices.invoice')} ${invoiceSelected ? invoiceSelected?.Invoice.code : ''}`"
    >
      <template #end>
        <ion-buttons slot="end">
          <ion-menu-button :auto-hide="false">
            <ion-icon id="popover-button" :icon="ellipsisVertical" size="small" />
          </ion-menu-button>

          <ion-popover trigger="popover-button" :dismiss-on-select="true">
            <ion-content>
              <ion-list>
                <ion-item @click="handleDownloadInvoice()" :button="true" :detail="false">{{
                  t('invoices.download')
                }}</ion-item>
              </ion-list>
            </ion-content>
          </ion-popover>
        </ion-buttons>
      </template>
    </LargeNavbar>
    <ion-content class="welcome-wrapper bg-white">
      <div class="PageContainer mt-xs w-100 d-flex justify-space-center">
        <div v-if="!isLoading" class="content w-100">
          <RecipientInvoiceCard />

          <div class="mt-xs">
            <InvoiceDatesDetailCard />
          </div>

          <div class="mt-xs">
            <InvoicePaymentDetailsCard />
          </div>

          <div
            v-if="
              invoiceSelected &&
              (invoiceSelected.Invoice.status === 'pending' ||
                invoiceSelected.Invoice.status === 'sent')
            "
            class="mt-xs"
          >
            <ion-button
              :disabled="isLoadingPayment"
              fill="solid"
              expand="block"
              size="default"
              color="primary"
              class="text-lg text-weight-bold"
              @click="handleGetPaymentLink"
            >
              {{ t('invoices.payNow') }}
            </ion-button>
            <ion-progress-bar v-if="isLoadingPayment" type="indeterminate"></ion-progress-bar>
          </div>
        </div>
        <div v-else class="content w-100 gap-xs d-flex flex-column">
          <SkeletonLoaderCard :width="'100%'" />
          <SkeletonLoaderCard :width="'100%'" />
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>
<script setup lang="ts">
  import { onMounted, ref } from 'vue';
  import router from '@/router';
  import { useI18n } from 'vue-i18n';
  import {
    IonContent,
    IonPage,
    IonButton,
    IonProgressBar,
    IonMenuButton,
    IonList,
    IonItem,
    IonIcon,
    IonPopover,
    IonButtons,
  } from '@ionic/vue';
  import LargeNavbar from '@/components/LargeNavbar.vue';
  import { storeToRefs } from 'pinia';
  import { useBillingStore } from '@/stores/billing-store';
  import { useRoute } from 'vue-router';
  import RecipientInvoiceCard from '@/components/billing/RecipientInvoiceCard.vue';
  import InvoiceDatesDetailCard from '@/components/billing/InvoiceDatesDetailCard.vue';
  import InvoicePaymentDetailsCard from '@/components/billing/InvoicePaymentDetailsCard.vue';
  import SkeletonLoaderCard from '@/components/loaders/SkeletonLoaderCard.vue';
  import { ellipsisVertical } from 'ionicons/icons';

  const { t } = useI18n();

  const onBackButton = () => {
    router.back();
  };

  const { invoiceSelected } = storeToRefs(useBillingStore());
  const { getInvoice, getPaymentLink, downloadInvoice } = useBillingStore();
  const route = useRoute();
  const isLoading = ref(true);
  const isLoadingPayment = ref(false);

  const handleGetPaymentLink = async () => {
    try {
      isLoadingPayment.value = true;
      const data = await getPaymentLink(route.params.invoiceId as string);
      if (data.payment_link_url) {
        window.open(data.payment_link_url, '_system');
      }
    } catch (error) {
      console.error('error', error);
    } finally {
      isLoadingPayment.value = false;
    }
  };

  const handleDownloadInvoice = async () => {
    try {
      isLoadingPayment.value = true;
      const result = await downloadInvoice(route.params.invoiceId as string);
      if (result.data) {
        const blob = new Blob([result.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `invoice_${route.params.invoiceId as string}.pdf`;
        link.click();
      }
    } catch (error) {
      console.error('error', error);
    } finally {
      isLoadingPayment.value = false;
    }
  };

  const getInvoiceDetails = async () => {
    try {
      isLoading.value = true;
      await getInvoice(route.params.invoiceId as string);
    } catch (error) {
      console.error('error', error);
    } finally {
      isLoading.value = false;
    }
  };

  const initialConfig = () => {
    getInvoiceDetails();
  };

  onMounted(() => {
    initialConfig();
  });
</script>

<style lang="css" scoped></style>
